export class Operation {
  constructor(
    public name: string,
    public operation: () => void,
    public undoOperation: () => void
  ) {}
}
